( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'on-demand-program-slider', COMPONENT );
} )( app );
